import React, { useEffect, useState } from "react";
import { Form } from 'react-bootstrap';
import ReactSelect from 'react-select';
import { localize } from "services/base";
import { changeSelected, selected_data } from "signals/form";

const FormSelect = (props) => {
    const t = (key) => localize(key);
    const [listOptions, setListOptions] = useState([]);

    const {
        name,
        value,
        required,
        disabled,
        feedback,
        options,
        onChange,
        invalid,
        readOnly
    } = props;

    useEffect(() => {
        if (options) {
            const arr = [];
            Object.keys(options)?.forEach(data => {
                if (name === 'country' || name === 'country_dial_code') {
                    arr.push({
                        label: (name === 'country' ? options[data][0] : `+${options[data][1]}`),
                        value: data
                    })
                } else {
                    arr.push({
                        label: options[data],
                        value: data
                    })
                }
            });
            setListOptions(arr);
            if(value){
                let val = arr?.filter(option => option.value === value);
                if(val?.length > 0){
                    changeSelected(name,val[0])
                }
            }
        }
    }, [options, name, value]);

    const handleChange = (e) => {
        onChange(e);
    }

    return (
        <>
            <Form.Group className="mb-3" controlId={name}>
                <Form.Label className="fw-bold">
                    {t(`${name === 'country_dial_code' ? 'phone_number' : name}`)}
                    {required &&
                        <span className="text-danger"> *</span>
                    }
                </Form.Label>
                <Form.Control
                    hidden
                    type={`input`}
                    required={required}
                    name={name}
                    value={value}
                    isInvalid={invalid}
                    readOnly={true}
                />

                <ReactSelect
                    className="select-option"
                    classNamePrefix="select-option"
                    options={listOptions}
                    placeholder={t(`placeholder_${name}`)}
                    value={selected_data.value[name]}
                    onChange={(e) => handleChange(e)}
                    isDisabled={disabled}
                    readOnly={readOnly}
                />

                {feedback &&
                    <Form.Control.Feedback type="invalid">
                        {t(`${name}`)} {t(`error_select`)}
                    </Form.Control.Feedback>
                }
            </Form.Group>

        </>
    )


}

export default FormSelect;